import React from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import Button from "../../atoms/Button";
import { Link } from "react-router-dom";

const InquireConfirmation = ({ open, onCancel }) => {
    return (
        <DiaglogBox width={400} open={open} onCancel={onCancel}>
            <div className="pb-5">
                <h4
                    className="pt-8 pb-9 w-full text-black text-[1.5625rem] font-bold text-center"
                    style={{
                        background: "url('/images/purple_wave_bg.svg')",
                        backgroundRepeat: "no-repeat",
                    }}
                >
                    Notification
                </h4>
                <p className="text-center font-medium text-[14px] px-11 mb-4">
                    Notification has been sent to the Owner, Once the owner
                    lists these Credits to sell, you will be notified.
                </p>
                <Button
                    onClick={onCancel}
                    color={"blue"}
                    className={
                        "w-[150px] h-[40px] text-white text-sm font-bold block mx-auto"
                    }
                    varient={"primary"}
                >
                    Ok
                </Button>
            </div>
        </DiaglogBox>
    );
};

export default InquireConfirmation;
